import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-date-collected',
  templateUrl: './date-collected.component.html',
  styleUrls: ['./date-collected.component.css']
})
export class DateCollectedComponent implements OnInit {
  public title : string;

  constructor(public api:ApiService) { }

  ngOnInit() {
  }

  get dateFilterType(){
    return this.dates.type;
  }
  set dateFilterType(value){
    this.dates.type = value;
  }

  get years(){
    return this.api.session.years;
  }

  get selectedYears() : Entity[]{
    return this.api.session.currentCriteria.dates.selectedYears;
  }
  set selectedYears(value){
    this.api.session.currentCriteria.dates.selectedYears = value;
  }

  get dates(){
    return this.api.session.currentCriteria.dates;
  }

  onSelectionChange(newValue) {
    this.dates.isDateRange = newValue;
  }

  get isYearList(){
    return this.dates.isDateRange == false;
  }
  set isYearList(value){
    this.dates.isDateRange = !value;
  }

  clearCurrent(){
    this.api.session.currentCriteria.dates = MyUtility.deepCopy(this.api.originalCriteria.dates);
  }
}
